<!-- INFO -->
<section class="info-section">
  <mat-icon>info_outline</mat-icon>
  <div class="info-text">
    {{ 'map.sidebar.otdr.FAS.info_section' | translate }}
  </div>
</section>

<form class="mb-3 row" [formGroup]="form">
  <!-- device_urn -->
  <mat-form-field class="col mt-2" appearance="outline">
    <mat-label>{{ 'map.sidebar.otdr.FAS.form.object_label' | translate }}</mat-label>
    <input
      type="text"
      matInput
      formControlName="object"
      [matAutocomplete]="autoCampo1"
      [placeholder]="'map.sidebar.otdr.FAS.form.search_placeholder' | translate"
    />
    <mat-autocomplete #autoCampo1="matAutocomplete">
      <mat-option
        *ngFor="let result of searchResultsObject"
        [value]="result.desc"
        (click)="getEstremiOtdrFromSegmentoOttico(result.urns)"
      >
        {{ result.desc }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="form.get('object').hasError('optionError')">
      <ng-container *ngTemplateOutlet="errorOption"></ng-container>
    </mat-error>
    <mat-error *ngIf="form.get('object').hasError('solrError')">
      <ng-container *ngTemplateOutlet="errorSolr"></ng-container>
    </mat-error>
  </mat-form-field>
  <!-- <h4>{{ segmentoOttico.name }}</h4> -->
  <mat-form-field class="col mt-2" appearance="outline">
    <mat-label>Seleziona Estremo Fibra</mat-label>
    <mat-select formControlName="device_urn">
      <ng-container *ngFor="let estremo of estremiFibra">
        <mat-option *ngFor="let item of estremo | keyvalue" [value]="item.key">
          {{ item.value }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="col mt-2" appearance="outline">
    <mat-label>Lunghezza Segmento</mat-label>
    <input matInput type="number" formControlName="distance" placeholder="Ex. 100m" />
  </mat-form-field>
</form>
<ebw-monorepo-as-footer
  [styleContainer]="'buttons-wrapper'"
  [styleWrapper]="'buttons-wrapper'"
  [buttons]="buttons"
  (changeComponentHandler)="onChangeComponentHandler($event)"
></ebw-monorepo-as-footer>

<!-- FORM ERROR TEMPLATES -->
<ng-template #errorSolr>{{ 'map.sidebar.otdr.default.form.error_solr' | translate }}</ng-template>
<ng-template #errorOption>{{ 'map.sidebar.otdr.default.form.error_option' | translate }}</ng-template>
